<cass-core-toolbar></cass-core-toolbar>
<div class='page-container'>
	<mat-card class="branding--title-card">
		<mat-card-content>
			<h1>{{ "SYS_NOTIFICATIONS.NOTIFICATIONS_PAGE.MAIN_TITLE" | translate }}</h1>
		</mat-card-content>
	</mat-card>
	<app-notifications-list></app-notifications-list>
</div>
